import { gql } from '@apollo/client';

export interface Zuordnungsoption {
  id: number;
  title: string;
}

export interface ZuordnungsoptionenAntwort {
  getAllBranchOffice: Zuordnungsoption[] | null;
  getAllContractTypes: Zuordnungsoption[] | null;
}

export const GET_VORLAGEN_ZUORDNUNG_OPTIONEN = gql`
  query getVorlagenZuordnungOptionen {
    getAllBranchOffice {
      id
      title
    }
    getAllContractTypes {
      id
      title
    }
  }
`;
